// Mock data for Ruma Logistics Landing Page

export const features = [
  {
    id: 1,
    title: "Color-Coded CRM",
    description: "See at a glance which stores need attention. Green means visited today, Purple means under 30 days, Orange under 45 days, and Red means overdue.",
    icon: "Palette"
  },
  {
    id: 2,
    title: "Instant History",
    description: "The 'P' button reveals the entire invoice history for any store. No digging through paperwork—just tap and see.",
    icon: "History"
  },
  {
    id: 3,
    title: "One-Tap Discovery",
    description: "Found a new store? GPS Quick-Add checks for duplicates within 250m and auto-fills the address using reverse geocoding.",
    icon: "MapPin"
  },
  {
    id: 4,
    title: "Dual Inventory",
    description: "Track warehouse and van stock separately. Items deduct from van inventory instantly when you create an invoice.",
    icon: "Package"
  },
  {
    id: 5,
    title: "Smart Invoicing",
    description: "Context-aware invoicing pre-fills store details. The Sales List lets you quick-add favorite items without scrolling.",
    icon: "FileText"
  },
  {
    id: 6,
    title: "Route Optimization",
    description: "One tap calculates the fastest path from your location, assigns stop numbers, and saves you hours of driving.",
    icon: "Route"
  }
];

export const workflowSteps = [
  {
    step: 1,
    title: "Load Up",
    description: "Move stock from warehouse to van. The inventory tab shows exactly what's available and what you're taking.",
    icon: "PackagePlus"
  },
  {
    step: 2,
    title: "Drive Smart",
    description: "Hit 'Optimize' and watch your route reorder. Each store gets a stop number—no guesswork, just GPS efficiency.",
    icon: "Navigation"
  },
  {
    step: 3,
    title: "Sell Fast",
    description: "Tap 'I' to create an invoice for any store instantly. Use the Sales List popup to add all the products sold to that store including the total sum of any refill product in a second.",
    icon: "Zap"
  },
  {
    step: 4,
    title: "Track It",
    description: "Dashboard shows sales by route, by salesman, and expense tracking—all filtered by date.",
    icon: "BarChart3"
  }
];

export const statusColors = {
  visitedToday: { color: "#22c55e", label: "Visited Today" },
  under30Days: { color: "#a855f7", label: "< 30 Days" },
  under45Days: { color: "#f97316", label: "< 45 Days" },
  overdue: { color: "#ef4444", label: "> 45 Days" },
  inProgress: { color: "#eab308", label: "In Progress" },
  notes: { color: "#3b82f6", label: "Notes" },
  importantNote: { color: "#f97316", label: "Important" },
  history: { color: "#14b8a6", label: "History" }
};

export const testimonials = [
  {
    id: 1,
    name: "Marcus Rodriguez",
    role: "Independent Distributor, Dallas",
    quote: "Went from 3 hours of route planning to 15 minutes. The color coding alone saves me from missing visits.",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    role: "Fleet Manager, Houston",
    quote: "My drivers complete 20% more stops daily. The GPS optimization is a game-changer.",
    rating: 5
  },
  {
    id: 3,
    name: "Sarah Thompson",
    role: "Distribution Owner, Austin",
    quote: "Finally ditched the carbon copy invoices. Professional PDFs, accurate math, happy customers.",
    rating: 5
  }
];

export const stats = [
  { value: "2.5x", label: "More Stops Per Day" },
  { value: "85%", label: "Less Paperwork" },
  { value: "Zero", label: "Setup Required" },
  { value: "24/7", label: "Cloud Access" }
];

export const faqItems = [
  {
    question: "Do I need to set anything up myself?",
    answer: "Absolutely not. Our concierge team configures your database, imports your products, sets up your routes, and adds your stores. You just log in and start driving."
  },
  {
    question: "Does it work offline?",
    answer: "Yes! Ruma Logistics is a Progressive Web App (PWA) that caches your routes and store data. Create invoices offline and they sync when you're back online."
  },
  {
    question: "How does the color-coded visit system work?",
    answer: "Each store automatically updates based on your last visit: Green for today, Purple for under 30 days, Orange for under 45 days, and Red for overdue stores that need attention."
  },
  {
    question: "Can I track multiple salesmen?",
    answer: "Yes. Each salesman has their own van inventory, and the dashboard shows sales and expenses broken down by salesman."
  },
  {
    question: "What's the Refill List feature?",
    answer: "It's a specialized checklist for counting items for specific products. Count in the store, pickup in the van, tap Transfer, and the total automatically adds to your sales list with other items you have sold in the store. One tap to add everything to the invoice."
  }
];
